<template>
    <layout-internal-container>
        <div class="w-full flex flex-col gap-5">
            <div class="flex flex-col gap-4 md:flex-row justify-between">
                <div class="flex flex-row gap-2 items-center">
                    <span v-for="item in statusOption"
                        :class="item === statusActive ? 'bg-primary text-white' : 'bg-white border text-light'"
                        class="rounded-full px-3 py-1 items-center h-fit flex text-xs cursor-pointer"
                        @click="onClickStatus(item)" :key="item">{{ item }}</span>
                </div>

                <div @click="$router.push('/Course/Discovery')"
                    v-if="myCourses?.length > 0"
                    class="text-primary flex flex-row justify-center cursor-pointer text-sm items-center gap-2 w-fit">
                    <span class="font-medium">Explore New Course</span>
                    <IconArrowRight :size="18" />
                </div>
            </div>

            <div v-if="isCoursesLoaded">
                <div class="w-full gap-4 grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3" v-if="myCourses?.length > 0">
                    <card-course class="md:min-w-[15rem] lg:min-w-[20rem]" v-for="item in myCourses" :key="item.course.id" 
                        :title="item.course.title" 
                        :duration="item.course.duration"
                        :rating="item.course.rating" 
                        :image="item.course.photo" 
                        :enroll="item.course.total_reviews" 
                        :lesson="item.course.total_lessons"
                        :completed="item.course.total_completed"
                        :finished="item.course.finished_percentage"
                        :id="item.course.id" 
                        :slug="item.course.slug" 
                        :featured="item.course.featured"
                        :category="item.course.category" 
                        :speakerName="item.course.speaker_name"
                        :speakerPhoto="item.course.speaker_photo"
                        :isFree="item.program_id == null"
                        :enrolled="true" 
                        />
                </div>

                <div class="w-full gap-2 flex flex-row items-center justify-center mt-8" v-else>
                    <p>No Course Found.</p>

                    <div @click="$router.push('/Course/Discovery')"
                        class="text-primary flex flex-row justify-center cursor-pointer text-sm items-center gap-1">
                        <p>Explore New Course</p>
                        <IconArrowRight :size="18" />
                    </div>
                </div>
            </div>
        </div>
    </layout-internal-container>
</template>
  
<script setup>
import { ref, onMounted } from 'vue'
import axios from "@/plugins/axios";
import DummyCategory from '../../assets/Dummy/category.js'
import { IconSearch, IconArrowRight, IconSortDescending, IconCategory2, IconChartDonut, IconCalendarMonth, IconTrophy, IconAlarm, IconHourglassEmpty, IconCertificate2, IconRotateClockwise2 } from '@tabler/icons-vue'

const tab = ref('All')
const myCourses = ref(null)
const isCoursesLoaded = ref(false)
const category = ref([])
const statusOption = ref(['All', 'Ongoing', 'Completed'])
const statusActive = ref('All')

const fetchMyCourses = async () => {
    try {
        const response = await axios.get('/my-course', {
            params: {
                status: statusActive.value,
            }
        })

        myCourses.value = response?.data?.data
        isCoursesLoaded.value = true
    } catch (error) {
        console.error('Error fetching my myCourses:', error)
    }
}

const onClickStatus = (status) => {
    statusActive.value = status
    
    fetchMyCourses()
}

onMounted(() => {
    fetchMyCourses();
    category.value = DummyCategory.map((t) => ({ value: t.id, label: t.title }))
})
</script>
  